import loadable from '@loadable/component';

export const AsyncNeighborhoods = loadable(
    () =>
        import(
            /* webpackChunkName: "neighborhoods" */
            /* webpackPrefetch: true */
            './'
        ),
    {ssr: false}
);

AsyncNeighborhoods.displayName = 'AsyncNeighborhoods';
